// ==========================
// Version 1 - wallet/useWalletReservation.js
// - Subscribes to wallet_links/{address} so a wallet can belong to one user
// ==========================
import React from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { normalizeWalletAddress } from "./walletLinking";

export function useWalletReservation(address) {
  const normalizedAddress = normalizeWalletAddress(address);
  const [state, setState] = React.useState({
    loading: !!normalizedAddress,
    reservation: null,
    error: null,
  });

  React.useEffect(() => {
    if (!normalizedAddress) {
      setState({ loading: false, reservation: null, error: null });
      return undefined;
    }

    setState((prev) => ({ ...prev, loading: true, error: null }));

    const ref = doc(db, "wallet_links", normalizedAddress);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setState({
          loading: false,
          reservation: snap.exists() ? snap.data() : null,
          error: null,
        });
      },
      (error) => {
        setState({
          loading: false,
          reservation: null,
          error,
        });
      }
    );

    return unsub;
  }, [normalizedAddress]);

  return state;
}

// ==========================
// End Version 1 - wallet/useWalletReservation.js
// ==========================
